export default "__VITE_ASSET__4e098933__"